import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit'
import notification from 'antd/es/notification/index'
import { newRelic } from '../../utils/new-relic.ts'

function isErrorAction(
  action: unknown
): action is { payload: { status: string; data: { errorCode: string } } } {
  if (typeof action === 'object' && action !== null && 'payload' in action) {
    const payload = (action as Record<string, unknown>).payload
    if (
      typeof payload === 'object' &&
      payload !== null &&
      'status' in payload &&
      'data' in payload
    ) {
      const data = (payload as Record<string, unknown>).data
      return typeof data === 'object' && data !== null && 'errorCode' in data
    }
  }
  return false
}

export const unauthorizedMiddleware: Middleware = () => (next) => (action) => {
  if (
    isErrorAction(action) &&
    isRejectedWithValue(action) &&
    action.payload.data.errorCode === 'InvalidAuthToken'
  ) {
    notification.error({
      message: 'Auth token expired, logout in 3 seconds',
    })
    newRelic.noticeError(new Error('InvalidAuthToken, forcing logout'), {
      context: 'unauthorizedMiddlewareForcedLogout',
    })

    setTimeout(() => {
      window.location.href = '/logout'
    }, 3000)
  }

  return next(action)
}
